import Comment from "./SVG/comment.svg?react";

const CommentIcon = () => {
  return <Comment />;
};

export default CommentIcon;
